import injectSheet from 'react-jss'
import DropDown from './DropDown'
import styles from './DropDown.styles'

export default injectSheet(styles)(DropDown)
